export default {
  DEFAULT_HEADER_REF_ORDER: "creationDate",
  ORDER_DESC: "DESC",
  ORDER_ASC: "ASC",
  SORT_ICON: {
    PREFIX_CLASS: "fa ",
    ORDER_ASC_ICON: "fa-caret-up",
    ORDER_DESC_ICON: "fa-caret-down"
  },
  STATUS: {
    DRAFT: "DRAFT"
  },
  MAX_ATTACHMENTS: 10,

  THUMBNAIL_CROP_WIDTH:450,
  THUMBNAIL_CROP_HEIGHT:300,

  HERO_CROP_WIDTH:930,
  HERO_CROP_HEIGHT:620,

  THUMBNAIL: "THUMBNAIL",
  HERO: "HERO"

};
